<template>
    <transition-group name="fade-absolute">
        <div key="loading" class="flex justify-center" v-if="loading">
            <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div key="products" class="relative" :class="{ 'my-lg': search !== undefined }" v-else-if="products.length">
            <div v-if="search !== undefined">
                <span class="font-semibold inline-block mb-xxs">Zoekresultaten</span>
            </div>
            <div class="-m-sm flex flex-wrap" :class="{ /*'justify-center'*/ '': products.length < 4 }" ref="productcontainer">
                <div class="w-1/2 p-sm sm:w-1/3 md:w-1/4" v-for="product in products" :key="product.id">
                    <template v-if="product && product.acf">
                        <a :href="`${possibleLangPrefix}/product/${product.slug}`" class="block-img-hover block">
                            <div class="relative">
                                <div :class="orientation == 'portrait' ? 'aspect-w-2 aspect-h-3' : orientation == 'landscape' ? 'aspect-w-3 aspect-h-2' : 'aspect-w-1 aspect-h-1'"></div>
                                <picture class="absolute top-0 left-0 h-full w-full" v-if="product.acf.image">
                                    <img :data-src="product.acf.image.url" :alt="product.title.rendered" class="lazyload h-full w-full object-cover" />
                                </picture>

                                <div class="block-img-hover__icon">
                                    <i class="fa-regular fa-arrow-right"></i>
                                </div>
                            </div>

                            <div class="mt-xs flex items-center w-full">
                                <span :class="{ 'do-not-translate': shouldNotTranslate(product) }" class="text-xs xs:text-sm font-bold uppercase tracking-[2px] text-gray-300" v-html="product.title.rendered"></span>
                            </div>
                        </a>
                    </template>
                </div>

                <div class="w-full">
                    <pagination :current-page="params.page" :total-pages="totalPages" @next-page="filter(params.page + 1)" @previous-page="filter(params.page - 1)" @go-to-page="(event) => filter(event.page)"> </pagination>
                </div>
            </div>
        </div>
        <div key="empty" v-else-if="timeout === null && search && search.length">
            <p class="my-lg text-center">Geen producten gevonden. Probeer een andere zoekopdracht.</p>
        </div>
    </transition-group>
</template>

<script>
import axios from 'axios';
var scrollIntoView = require('scroll-into-view');

export default {
    name: 'productsoverview',

    props: {
        search: {
            type: String,
            required: false,
        },

        category: {
            type: Number | Array,
            required: false,
        },

        productIds: {
            type: Number | Array,
            required: false,
        },

        orientation: {
            type: String,
            required: false,
            default: 'portrait',
        },
    },

    data() {
        return {
            params: {
                per_page: 16,
                page: 1,
                'product-category': [],
                include: [],
                paginate: true,
            },
            loading: false,
            timeout: null,
            products: [],
            totalPages: 0,
        };
    },

    mounted() {
        if (this.category) {
            this.params['product-category'] = typeof this.category === 'object' ? this.category : [this.category];
            this.getProducts(1, false);
        }
        if (this.productIds) {
            this.params['include'] = typeof this.productIds === 'object' ? this.productIds : [this.productIds];
            this.getProducts(1, false);
        }
    },

    methods: {
        filter(page) {
            if (page) {
                this.params.page = page;
            } else {
                this.params.page = 1;
            }

            this.getProducts(page);
        },

        clearProducts() {
            this.products = [];
            this.loading = false;
            this.totalPages = 0;
        },

        getProducts(page, scroll = true) {
            this.loading = true;

            if (scroll) {
                scrollIntoView(this.$refs.productcontainer);
            }

            let params = this.params;

            if (this.search) {
                params.search = this.search;
            }

            axios
                .get('/api/my-products', { params: { ...params } })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.products = response.data.data.results;
                        this.totalPages = Math.ceil(parseInt(response.data.data.meta.total) / this.params.per_page);
                    } else {
                        this.articles = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        shouldNotTranslate(product) {
            return ['nederlands', 'frans', 'duits', 'chinees', 'engels'].some((r) => product.categories_objects.map((c) => c.slug).includes(r));
        },
    },

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },

    watch: {
        search() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.timeout = setTimeout(() => {
                if (this.search === '') {
                    this.clearProducts();
                } else {
                    this.getProducts(1, false);
                }
                this.timeout = null;
            }, 500);
        },
    },
};
</script>
